<template>
  <div class="frame-page h-full !m-0px p-20px flex flex-column">
  <vxe-toolbar class="bg-white-color p-16px">
    <template #buttons>
      <DatePicker type="month" v-model="params.start" :clearable="false" :option="{end:params.end}"/>
      <span class="mx-8px">至</span>
      <DatePicker type="month" v-model="params.end" :clearable="false" :option="{start:params.start}"/>
      <Button @click="loadList()" class="mx-8px" color="primary" icon="fa fa-search">查询</Button>
    </template>
    <template #tools>
      <vxe-button  v-print="'#printSection'" content="打印" icon="fa fa-print"/>
      <vxe-button @click="exportClick" content="导出" icon="fa fa-download"/>
    </template>
  </vxe-toolbar>
  <div class="flex-1 h-0px overflow-y bg-white-color">
    <div style="padding-left: 16px;font-size: 14px;font-weight: 900;color:#606266">现金类</div>
    <vxe-table :data="cashList" class="mx-16px mb-8px" border :highlight-current-row="false">
      <vxe-column title="编码" field="code"/>
      <vxe-column title="账户名称" field="name"/>
      <vxe-column title="期初余额" field="initialBalance" align="right" formatter="toMoney"/>
      <vxe-column title="收入总额" field="sr" align="right" formatter="toMoney"/>
      <vxe-column title="支出总额" field="zc" align="right" formatter="toMoney"/>
      <vxe-column title="余额" field="balance" align="right" formatter="toMoney"/>
    </vxe-table>
    <div style="padding-left: 16px;font-size: 14px;font-weight: 900;color:#606266">银行类</div>
    <vxe-table :data="bankList" class="mx-16px mb-8px" border :highlight-current-row="false">
      <vxe-column title="编码" field="code"/>
      <vxe-column title="账户名称" field="name"/>
      <vxe-column title="期初余额" field="initialBalance" align="right" formatter="toMoney"/>
      <vxe-column title="收入总额" field="sr" align="right" formatter="toMoney"/>
      <vxe-column title="支出总额" field="zc" align="right" formatter="toMoney"/>
      <vxe-column title="余额" field="balance" align="right" formatter="toMoney"/>
    </vxe-table>
    <!-- <vxe-table row-class-name="highlight-aggregate" :data="aggregateData" class="mx-16px mb-8px" border :show-header="false" :highlight-current-row="false">
      <vxe-column title="编码" field="code"/>
      <vxe-column title="账户名称" field="name"/>
      <vxe-column title="期初余额" field="initialBalance" align="right" formatter="toMoney"/>
      <vxe-column title="收入总额" field="sr" align="right" formatter="toMoney"/>
      <vxe-column title="支出总额" field="zc" align="right" formatter="toMoney"/>
      <vxe-column title="余额" field="balance" align="right" formatter="toMoney"/>
    </vxe-table> -->
  </div>
   <!-- jxd原生打印区域 -->
   <div style="width: 0;height: 0;overflow: hidden;">
    <div id="printSection">
      <table class="w-full mx-16px mb-8px border-collapse" style="
        width: 98%;
        border: #ccc 1px solid;
        border-spacing: 0;
        border-collapse: collapse;
      ">
        <thead style="background-color: #f2f2f2;">
          <tr>
            <th style="padding: 8px;border: 1px solid #ccc; font-weight: bold;text-align: center;">编码</th>
            <th style="padding: 8px; border: 1px solid #ccc; font-weight: bold;text-align: center;">账户名称</th>
            <th style="padding: 8px; border: 1px solid #ccc; font-weight: bold;text-align: center;">期初余额</th>
            <th style="padding: 8px; border: 1px solid #ccc; font-weight: bold;text-align: center;">收入总额</th>
            <th style="padding: 8px; border: 1px solid #ccc; font-weight: bold;text-align: center;">支出总额</th>
            <th style="padding: 8px; border: 1px solid #ccc; font-weight: bold;text-align: center;">余额</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in allList" :key="index">
            <td style="padding: 8px; border: 1px solid #ccc;text-align: center;">{{ item.code }}</td>
            <td style="padding: 8px; border: 1px solid #ccc;text-align: center;">{{ item.name }}</td>
            <td style="padding: 8px; border: 1px solid #ccc;text-align: center;">{{ item.initialBalance == 0 ? '' : item.initialBalance }}</td>
            <td style="padding: 8px; border: 1px solid #ccc;text-align: center;">{{ item.sr == 0 ? '' : item.sr }}</td>
            <td style="padding: 8px; border: 1px solid #ccc;text-align: center;">{{ item.zc == 0 ? '' : item.zc }}</td>
            <td style="padding: 8px; border: 1px solid #ccc;text-align: center;">{{ item.balance == 0 ? '' : item.balance }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "CheckUp"
}
</script>

<script setup>
import {ref} from "vue";
import manba from "manba";
import {useStore} from "vuex";
import CashierReport from "@/api/CashierReport";
import {layer} from "@layui/layer-vue";
import CashierAccount from "@/api/CashierAccount";//jxd
import accountbook from "@/api/accountbook";
import htmlToExcel from '@/utils/htmlToExcel'; // 直接导入 htmlToExcel 函数 

const store = useStore();
const currentAccountDate = manba(store.state.currentAccountSets.currentAccountDate);
const startDate = ref(currentAccountDate.startOf(manba.MONTH).format());
const endDate = ref(currentAccountDate.endOf(manba.MONTH).format());
const accountList = ref([]);//jxd

const cashList = ref([]);
const bankList = ref([]);
const allList = ref([]);

const params = ref({
  start: startDate,
  end: endDate,
})

const summaryCol = ['initialBalance', 'sr', 'zc', 'balance', 'srbs', 'zcbs'];

const aggregateData = ref([])

const exportClick = () => {
  htmlToExcel.exportExcel("核对总账.xlsx", "#printSection");
}

const getLastDayOfMonth = (dateString) => { 
    // 将字符串转换为Date对象  
    const date = new Date(dateString);  
      
    // 确保日期字符串是有效的  
    if (isNaN(date.getTime())) {  
        throw new Error('Invalid date string');  
    }  
      
    // 获取该月份的最后一天  
    let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);  
      
    // 将Date对象转换回字符串形式  
    const year = lastDay.getFullYear();  
    const month = String(lastDay.getMonth() + 1).padStart(2, '0');  
    const day = String(lastDay.getDate()).padStart(2, '0');  
      
    return `${year}-${month}-${day}`;  
}; 

const loadList = () => {
  const loadId = layer.load(1);
  let end = getLastDayOfMonth(params.value.end)
	let parmss = JSON.stringify(params.value);
	let parmsss = JSON.parse(parmss);
	parmsss.end = end;
  CashierReport.accountSummary(parmsss).then(({data}) => {
    //先查出资金账户交易总账，分别设置到银行，现金类
    cashList.value = (data || []).filter(val => val.type === '现金');
    bankList.value = (data || []).filter(val => val.type === '银行存款');
    //查询资金账户列表
    CashierAccount.list().then(({data}) => {
      let arr = data.filter(val => val.subjectId)
      accountList.value = arr;
      //根据账户列表查科目余额表
      let obj = {
        start: params.value.start,
        end: params.value.end,
        currencyId: null,
        levelStart: 1,
        levelEnd: 4,
        subjectStart: null,
        subjectEnd: null,
      }
      accountbook.loadSubjectBalance(Object.assign({
        showNumPrice: false
      }, obj)).then(({data}) => {
        //通过账户列表，整理科目余额
        accountList.value.forEach(item => {
          data.forEach(item2 => {
            if(item.subjectId == item2.subjectId){{
              if(item.type == '现金'){
                let obj = {'name':item2.subjectCode + '-' + item2.subjectName,'code':item2.subjectCode,'balance':item2.endBalance, 'initialBalance':item2.beginBalance,'sr':item2.debit,'zc':item2.credit};
                let index = cashList.value.findIndex((item3) => item3.id === item.id);
                if(index != -1){
                  cashList.value.splice(index+1, 0, obj)
                }
              }else if(item.type == '银行存款'){
                let obj = {'name':item2.subjectCode + '-' + item2.subjectName,'code':item2.subjectCode,'balance':item2.endBalance, 'initialBalance':item2.beginBalance,'sr':item2.debit,'zc':item2.credit};
                let index = bankList.value.findIndex((item3) => item3.id === item.id);
                if(index !== -1){
                  bankList.value.splice(index+1, 0, obj)
                }
              }
            }}
          })
        })
        //可以继续整理过滤掉没有绑定科目的
        console.log(cashList.value,bankList.value,accountList.value)
        //jxd合并的用于原生打印数据
        allList.value = [...cashList.value, ...bankList.value,...accountList.value];
        allList.value.forEach(val => {
          if(!val.code){val.code = ''}
          if(val.initialBalance){val.initialBalance = Number(val.initialBalance).toFixed(2);}
          if(val.sr){val.sr = Number(val.sr).toFixed(2)}
          if(val.zc){val.zc = Number(val.zc).toFixed(2)}
          if(val.balance){val.balance = Number(val.balance).toFixed(2)}
        })
      });
    })

  }).finally(() => {
    layer.close(loadId)
  })
}
loadList()
</script>
